import MnPlayer from "./js/mn-player.js";
import $ from "jquery";
// @ts-ignore
import noDataImgUrl from "/public/svg/noData.svg";
export type MnVideoPlayerOptions = {
  el: HTMLElement
  port: number
  host: string
  ws: string
  userId: string
  tenantId: string
  accessToken: string
  phone: string
  channelNo: string
  lang: string
  outerWorker?: Worker
  beginTime?: string
  renderType: 'wasm' | 'decode'
  streamType?: number
  showControlBar: boolean,
}
export type MnVideoPlayerPlayOptions = {
  beginTime: string
  streamType: number
}

export type MnVideoPlayerControlType = 'play' | 'stop'
  | 'audio' | 'speedDec' | 'speedInc' | 'fullscreen'
  | "close" | "refresh" | 'stream0' | 'stream1' | 'stream2'

export class MnVideoPlayer {
  canvasEl: HTMLCanvasElement | null = null
  playBtn: HTMLButtonElement | null = null
  audioBtn: HTMLButtonElement | null = null
  opt: MnVideoPlayerOptions | null = null
  el: HTMLElement | null = null
  $el: any | null = null
  player: MnPlayer | null = null
  beginTime?: string = ''
  streamType: number = 2
  videoTime: number = 0
  isPlaying: boolean = false
  isPlayStart: boolean = false
  isEnableAudio: boolean = false
  currentSpeed: number = 1
  isFullscreen: boolean = false
  resizeObserver: ResizeObserver | null = null
  outerWorker?: Worker | null = null
  noDataImg: HTMLImageElement | null = null
  showControlBar: boolean = false
  enableDoubleClickFullscreen: boolean = true
  id: string = ''
  timeCallbackFn: (time: number) => void = () => { }
  /* 控制回调 */
  controlCallbackFn: (type: MnVideoPlayerControlType) => boolean = () => true
  constructor(id: string = 'play') {
    // console.log('MnPlayer constructor')
    this.id = id
  }
  /* 判断是否支持硬解码 */
  async isSupportHardDecode() {
    if (!('VideoDecoder' in window) || !('EncodedVideoChunk' in window)) {
      return false;
    }

    // 检查是否支持常见的编解码器
    const testCodecs = ['avc1.42001E', 'vp8', 'vp9', 'av1'];
    for (const codec of testCodecs) {
      try {
        if (await VideoDecoder.isConfigSupported({ codec })) {
          return true;
        }
      } catch (e) {
        // 忽略错误，继续检查其他编解码器
      }
    }

    return false;
  }



  /* 参数配置,初始化dom */
  init(opt: MnVideoPlayerOptions) {
    this.opt = opt
    this.showControlBar = opt.showControlBar
    this.el = opt.el
    this.$el = $(opt.el)
    this.initDom()

    if (this.opt.streamType !== undefined) {
      this.streamType = this.opt.streamType;
    }
    this.beginTime = this.opt.beginTime;
    if (this.showControlBar) {
      this.initControlDom()
    }
    this.player = new MnPlayer(
      this.opt.phone,
      this.opt.channelNo,
      this.$el,
      this.canvasEl!,
      this.opt.lang,
      this.opt.renderType
    );
    this.player.port = this.opt.port;
    this.player.host = this.opt.host;
    this.player.ws = this.opt.ws;
    this.player.userId = this.opt.userId;
    this.player.tenantId = this.opt.tenantId;
    this.player.token = this.opt.accessToken;
    this.player.id = this.id;
    this.outerWorker = opt.outerWorker
    this.player.onPlaying = () => {
      if (this.playBtn) {
        this.isPlaying = true
        this.playBtn!.textContent = "⏸"
      }
    }
    this.player.onPaused = () => {
      if (this.playBtn) {
        this.isPlaying = false
        this.playBtn!.textContent = "▶"
      }
    }
    if (this.outerWorker) {
      this.player.outerWorker = this.outerWorker
    }
    this.player.timeCallback = (t: number) => {
      this.videoTime = t
      if (typeof this.timeCallbackFn == 'function') {
        this.timeCallbackFn(t)
      }
    }
    this.player.restartCallback = this.restart.bind(this)
  }
  initDom() {
    this.$el.css({
      position: 'relative',
    })
    this.el!.classList.add("mn-video-container");
    let canvasEl = document.createElement("canvas");
    this.canvasEl = canvasEl;
    canvasEl.setAttribute("class", "display");
    if (!this.el) {
      throw new Error('Element not initialized. Please call init() first.')
    }
    let height = this.el.clientHeight;
    let width = this.el.clientWidth;
    let pixelRatio = window.devicePixelRatio || 1;
    canvasEl.style.height = height + "px";
    canvasEl.style.width = width + "px";
    canvasEl.style.position = 'absolute'
    canvasEl.height = height * pixelRatio;
    canvasEl.width = width * pixelRatio;
    this.el.innerHTML = "";
    this.el.appendChild(canvasEl);
    /* 监听dom大小变化 */
    let debounceTime: any = null
    this.resizeObserver = new ResizeObserver((entries) => {
      /* 防抖 */
      clearTimeout(debounceTime)

      debounceTime = setTimeout(() => {
        for (const entry of entries) {
          if (entry.target === this.el) {
            this.resetCanvas(entry.contentRect.width, entry.contentRect.height);
          }
        }
      }, 50)
    });
    if (this.el) {
      this.resizeObserver?.observe(this.el);
    }
  }
  /* 初始化控制dom */
  initControlDom() {
    if (!this.el) {
      throw new Error('Element not initialized. Please call init() first.')
    }
    /* el双击全屏 */
    if (this.enableDoubleClickFullscreen) {
      this.el.addEventListener('dblclick', (e) => {
        e.stopPropagation()
        e.preventDefault()
        if (e.target !== this.canvasEl) {
          return
        }
        if (this.controlCallbackFn) {
          let isNext = this.controlCallbackFn('fullscreen')
          if (!isNext) return
        }
        if (!this.isFullscreen) {
          this.el!.requestFullscreen().then(() => {
            this.isFullscreen = true;
            fullscreenBtn.textContent = "⛶";
          }).catch(() => { });
        } else {
          document.exitFullscreen().then(() => {
            this.isFullscreen = false;
            fullscreenBtn.textContent = "⛶";
          }).catch(() => { });
        }
      })
    }



    if (this.el.querySelector(".mn-video-control-bar")) return;
    this.injectControlStyles();
    let controlDom = document.createElement("div");
    controlDom.setAttribute("class", "mn-video-control-bar");
    // noData.svg
    let noDataImg = document.createElement("img");
    noDataImg.src = noDataImgUrl;
    noDataImg.style.width = "20%";
    noDataImg.style.height = "20%";
    noDataImg.className = "mn-video-no-data-btn";
    this.noDataImg = noDataImg
    this.el.appendChild(noDataImg);
    /* 播放/暂停 */
    let playBtn = document.createElement("button");
    this.playBtn = playBtn
    playBtn.className = "mn-video-btn mn-video-play-btn";
    playBtn.textContent = "▶";
    playBtn.onclick = () => {

      if (this.isPlaying) {
        if (this.controlCallbackFn) {
          let isNext = this.controlCallbackFn('stop')
          if (!isNext) return
        }
        this.player?.pause();
        this.isPlaying = false;
        playBtn.textContent = "▶";
      } else {
        if (this.controlCallbackFn) {
          let isNext = this.controlCallbackFn('play')
          if (!isNext) return
        }
        if (this.player && this.isPlayStart) {
          this.player.resume();
        } else {
          this.play({ beginTime: this.beginTime || "", streamType: this.streamType });
        }
        this.isPlaying = true;
        playBtn.textContent = "⏸";
      }
    };
    controlDom.appendChild(playBtn);
    /* 音频开关 */
    let audioBtn = document.createElement("button");
    this.audioBtn = audioBtn
    audioBtn.className = "mn-video-btn mn-video-audio-btn";
    audioBtn.textContent = "🔇";
    audioBtn.onclick = () => {
      if (!this.player) return;
      if (this.controlCallbackFn) {
        let isNext = this.controlCallbackFn('audio')
        if (!isNext) return
      }
      this.isEnableAudio = !this.isEnableAudio;
      this.player.enableAudio(this.isEnableAudio);
      audioBtn.textContent = this.isEnableAudio ? "🔊" : "🔇";
    };
    controlDom.appendChild(audioBtn);
    if (this.beginTime) {
      /* 倍速 */
      const speedOptions = [0.5, 1, 2, 4, 8, 16, 32];
      let speedDecBtn = document.createElement("button");
      speedDecBtn.className = "mn-video-btn mn-video-speed-dec-btn";
      speedDecBtn.textContent = "<";
      speedDecBtn.onclick = () => {
        if (!this.player) return;
        if (this.controlCallbackFn) {
          let isNext = this.controlCallbackFn('speedDec')
          if (!isNext) return
        }
        let idx = speedOptions.indexOf(this.currentSpeed);
        idx = (idx - 1 + speedOptions.length) % speedOptions.length;
        this.currentSpeed = speedOptions[idx];
        this.player.changeSpeed(this.currentSpeed);
        speedDisplay.textContent = this.currentSpeed + "x";
      };
      controlDom.appendChild(speedDecBtn);
      let speedDisplay = document.createElement("span");
      speedDisplay.className = "mn-video-btn mn-video-speed-display";
      speedDisplay.textContent = "1x";
      controlDom.appendChild(speedDisplay);
      let speedIncBtn = document.createElement("button");
      speedIncBtn.className = "mn-video-btn mn-video-speed-inc-btn";
      speedIncBtn.textContent = ">";
      speedIncBtn.onclick = () => {
        if (!this.player) return;
        if (this.controlCallbackFn) {
          let isNext = this.controlCallbackFn('speedInc')
          if (!isNext) return
        }
        let idx = speedOptions.indexOf(this.currentSpeed);
        idx = (idx + 1) % speedOptions.length;
        this.currentSpeed = speedOptions[idx];
        this.player.changeSpeed(this.currentSpeed);
        speedDisplay.textContent = this.currentSpeed + "x";
      };
      controlDom.appendChild(speedIncBtn);



      /* 刷新 */
      let refreshBtn = document.createElement("button");
      refreshBtn.className = "mn-video-btn mn-video-refresh-btn";
      refreshBtn.textContent = "↻";
      refreshBtn.onclick = () => {
        if (this.controlCallbackFn) {
          let isNext = this.controlCallbackFn('refresh')
          if (!isNext) return
        }
        this.restart();
      };
      controlDom.appendChild(refreshBtn);
    }

    /* 码流 HD/SD 选项框 */
    const curStreamType = this.streamType;
    let streamWrap = document.createElement("div");
    streamWrap.className = "mn-video-stream-wrap";
    let streamBtn = document.createElement("button");
    streamBtn.className = "mn-video-btn mn-video-stream-btn";
    let streamList = document.createElement("ul");
    streamList.className = "mn-video-stream-list";
    let items = [
      { label: "FHD", value: 0 },
      { label: "HD", value: 1 },
      { label: "SD", value: 2 },
    ];
    if (this.beginTime) {
      items = [
        { label: "HD", value: 1 },
        { label: "SD", value: 2 },
      ]
    } else {
      items = [
        { label: "HD", value: 0 },
        { label: "SD", value: 1 },
      ]
    }
    streamBtn.textContent = items.find((item) => item.value === curStreamType)?.label || "SD";
    items.forEach((item) => {
      let li = document.createElement("li");
      li.textContent = item.label;
      li.dataset.value = String(item.value);
      li.onclick = (e) => {
        e.stopPropagation();
        if (!this.player) return;
        let val = item.value;
        if (this.controlCallbackFn) {
          let isNext = this.controlCallbackFn(('stream' + val) as any)
          if (!isNext) return
        }
        this.streamType = val;
        this.switchStream(val);
        streamBtn.textContent = item.label;
        streamList.classList.remove("mn-video-stream-list-open");
      };
      streamList.appendChild(li);
    });
    streamBtn.onclick = () => {
      streamList.classList.toggle("mn-video-stream-list-open");
    };
    document.addEventListener("click", (e) => {
      if (!streamWrap.contains(e.target as Node)) {
        streamList.classList.remove("mn-video-stream-list-open");
      }
    });
    streamWrap.appendChild(streamBtn);
    streamWrap.appendChild(streamList);
    controlDom.appendChild(streamWrap);




    /* 关闭 */
    let closeBtn = document.createElement("button");
    closeBtn.className = "mn-video-btn mn-video-close-btn";
    closeBtn.textContent = "✕";
    closeBtn.onclick = () => {
      if (this.controlCallbackFn) {
        let isNext = this.controlCallbackFn('close')
        if (!isNext) return
      }
      this.stop();
      setTimeout(() => {
        this.init(this.opt!)
      }, 100);
    };
    controlDom.appendChild(closeBtn);
    /* 弹性空白 */
    let spacer = document.createElement("span");
    spacer.className = "mn-video-spacer";
    controlDom.appendChild(spacer);
    /* 全屏/退出全屏 */
    let fullscreenBtn = document.createElement("button");
    fullscreenBtn.className = "mn-video-btn mn-video-fullscreen-btn";
    fullscreenBtn.textContent = "⛶";
    fullscreenBtn.onclick = () => {
      if (!this.el) return;
      if (this.controlCallbackFn) {
        let isNext = this.controlCallbackFn('fullscreen')
        if (!isNext) return
      }
      if (!this.isFullscreen) {
        this.el.requestFullscreen().then(() => {
          this.isFullscreen = true;
          fullscreenBtn.textContent = "⛶";
        }).catch(() => { });
      } else {
        document.exitFullscreen().then(() => {
          this.isFullscreen = false;
          fullscreenBtn.textContent = "⛶";
        }).catch(() => { });
      }
    };
    document.addEventListener("fullscreenchange", () => {
      if (!document.fullscreenElement) {
        this.isFullscreen = false;
      }
    });
    controlDom.appendChild(fullscreenBtn);
    this.el.appendChild(controlDom);
  }
  injectControlStyles() {
    if (document.getElementById("mn-video-control-styles")) return;
    let style = document.createElement("style");
    style.id = "mn-video-control-styles";
    style.textContent = `
.mn-video-control-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  padding: 0 4px;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.2s;
  z-index: 10;
}
  .mn-video-no-data-btn {
    user-select: none;
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 20px;
    min-height: 20px;
  }
.mn-video-container:hover .mn-video-control-bar,
.mn-video-control-bar:hover {
  opacity: 1;
}
.mn-video-btn {
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  line-height: 20px;
  padding: 0 4px;
  white-space: nowrap;
  outline: none;
  user-select: none;
}
.mn-video-btn:hover {
  background: rgba(255,255,255,0.2);
  border-radius: 2px;
}
.mn-video-spacer {
  flex: 1;
}
.mn-video-stream-wrap {
  font-size: 0px;
  position: relative;
}
.mn-video-stream-list {
  display: none;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin: 0 0 2px 0;
  padding: 2px 0;
  list-style: none;
  background: rgba(40,40,40,0.95);
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 3px;
  min-width: 40px;
  z-index: 20;
}
.mn-video-stream-list-open {
  display: block;
}
.mn-video-stream-list li {
  padding: 2px 12px;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
}
.mn-video-stream-list li:hover {
  background: rgba(255,255,255,0.15);
}
`;
    document.head.appendChild(style);
  }
  resetCanvas(w?: number, h?: number) {
    if (!this.canvasEl) {
      // throw new Error('Canvas not initialized. Please call init() first.')
      console.error('Canvas not initialized. Please call init() first.')
      return
    }
    let height = this.el!.clientHeight;
    let width = this.el!.clientWidth;
    if (w) {
      width = w
    }
    if (h) {
      height = h
    }
    let pixelRatio = window.devicePixelRatio || 1;
    this.canvasEl.style.height = height + "px";
    this.canvasEl.style.width = width + "px";
    this.canvasEl.height = height * pixelRatio;
    this.canvasEl.width = width * pixelRatio;
  }
  removeDom() {


    if (this.canvasEl) {
      this.canvasEl.remove();
      this.canvasEl = null;
      /* 移除监听 */
      this.resizeObserver?.disconnect();
    }
    if (this.el) {
      this.el.innerHTML = "";
    }
  }
  resetAudioOffset(time: number = 0) {
    this.player?.resetAudioOffset(time)
  }
  play(opt: MnVideoPlayerPlayOptions) {
    if (!this.opt) {
      throw new Error('Options not initialized. Please call init() first.')
    }
    // console.log('MnPlayer play', opt)
    if (opt?.beginTime !== undefined) {
      this.beginTime = opt?.beginTime
      this.opt.beginTime = opt?.beginTime
    }
    // console.log('this.beginTime', this.beginTime)
    if (!this.player) {
      // console.log('重新生成player')
      // this.initDom()
      // this.initControlDom()
      // this.player = new MnPlayer(
      //   this.opt.phone,
      //   this.opt.channelNo,
      //   this.$el!,
      //   this.canvasEl!,
      //   this.opt.lang || '',
      //   this.opt.renderType
      // );
      this.init(this.opt)
    }
    let type = opt?.streamType !== undefined ? opt.streamType : 1
    if (opt?.streamType === 0) {
      type = 0
    }
    this.streamType = type
    this.opt.streamType = type
    this.player!.play(0, type, this.beginTime);
    this.isPlayStart = true
    this.noDataImg?.remove()
    this.noDataImg = null
    if (this.playBtn) {
      this.playBtn!.textContent = "⏸"
    }
    // console.log('this.player', this.player)
  }
  pause() {
    if (this.player) {
      this.player.pause();
    }
    if (this.playBtn) {
      this.playBtn!.textContent = "▶"
    }
  }
  resume() {
    if (this.player) {
      this.player.resume();
    }
    if (this.playBtn) {
      this.playBtn!.textContent = "⏸"
    }
  }
  stop() {
    if (this.player) {
      this.player.stop();
      this.player = null
      this.isPlayStart = false
      this.isEnableAudio = false
      this.isPlaying = false
      this.currentSpeed = 1

      this.removeDom()
    }
  }
  restart() {
    if (this.beginTime ) {
      this.stop()
      // console.log('this.formatDateTime(new Date(this.videoTime))', this.formatDateTime(new Date(this.videoTime)))
      if (this.opt) {
        let time = new Date(this.beginTime)
        if (this.videoTime) {
          time = new Date(this.videoTime)
        }
        this.play({
          streamType: this.streamType!,
          beginTime: this.formatDateTime(time)
        })
        this.enableAudio(this.isEnableAudio)
      }
    } else {
      console.log('非回放模式禁止重载', this.beginTime, this.videoTime)
    }
  }
  switchStream(type: number) {
    console.log('MnPlayer switchStream')
    this.streamType = type
    if (this.opt) {
      this.opt.streamType = type
    }
    if (this.player) {
      this.player.switchStream(type);
    }
    if (this.beginTime && this.showControlBar) {
      this.restart()
    }
  }
  enableAudio(enable: boolean) {
    console.log('MnPlayer enableAudio')
    this.isEnableAudio = enable
    if (this.audioBtn) {
      this.audioBtn!.textContent = enable ? "🔊" : "🔇"
    }
    if (this.player) {
      this.player.enableAudio(enable);
    }
  }
  timeCallBack(callback: (time: number) => void) {
    this.timeCallbackFn = callback
  }
  changeSpeed(speed: number) {
    console.log('MnPlayer changeSpeed')
    if (this.player) {
      this.player.changeSpeed(speed);
    }
  }
  formatDateTime(date: Date) {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return "";
    }
    const pad = (n: number) => n.toString().padStart(2, "0");
    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      " " +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes()) +
      ":" +
      pad(date.getSeconds())
    );
  }

  setSyncTime(time:number){
    let d = this.videoTime - time
    if (this.player && this.videoTime > 1000) {
      this.player.delayTime?.(d)
    }
  }
}

export default MnVideoPlayer
